let cardhobby = {
  addressPage: {
    pageindex: 1,
    pagesize: 999
  },
  sort: [
    'lastontime',
    'price',
    'sales'
  ],
  sortType: [
    'desc',
    'asc'
  ],
  pointOptions: [{
          'value': 'All',
        }, {
          'value': '0-100',
        }, {
          'value': '100-200',
        }, {
          'value': '200-500',
        }],
  dislogType: {
    'market': false,
    'userinfo': false,
    'login': false,
    'register': false,
    'forgot': false,
    'address': false,
    'setOrderAddress': false,
    'payOrder': false,
    'viewexpress': false
  },
  authorize: [
    "../../static/images/footer_mci.svg",
    "../../static/images/footer_fbc.svg",
    "../../static/images/footer_sad.svg",
    "../../static/images/footer_rbf.svg",
    "../../static/images/footer_celtic.svg",
    // "../../static/images/footer_nbpa.svg",
    // "../../static/images/footer_ufc.svg"
  ],
  headerMeu: {
    'home': 'Home',
    'market': 'Market',
    'point': 'Points',
    'cypher': 'Cypher',
    'information': 'Information',
    'about': 'About US'
  },
  otherPayOrder: [
  {
    'method': 'SESOLT21XXX',
    'account': 'LT643710020000011418',
    'company':'Cardhobby Germany GmbH'
  }
  ],
  cosConfig: {
    ImagesUrl: "https://images.cardhobby.com/",
    Bucket: "cardhobby-1255531135" /* 必须 */ ,
    Region: "ap-shanghai" /* 存储桶所在地域，必须字段 */ ,
    Key: "exampleobject" /* 必须 */ ,
    Prefix: "", //CardHobby/ /*文件目录*/
    SecretId: "",
    SecretKey: ""
  },
}
export default {
  cardhobby
}



// WEBPACK FOOTER //
// ./src/api/enum.js